import Score from "./score";

class Game extends Score {

  type_game = 'sector'

  constructor(store, default_game, urls = window.URLS) {
    super(store, default_game, urls, 'sector')
  }

  getPriorityHits() {
    return [[20, 3], [20, 2], [20, 1]]
  }
}

export default Game